var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayment = function SvgPayment(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M17.091.02H2.883C1.293.02 0 1.369 0 3.027v7.292c0 1.659 1.293 3.008 2.883 3.008h14.38c1.495 0 2.711-1.268 2.711-2.826V3.027c0-1.658-1.293-3.007-2.883-3.007z",
    transform: "translate(6 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M17.091.02H2.883C1.293.02 0 1.369 0 3.027v1.216c0 .453.367.82.82.82h18.334c.453 0 .82-.367.82-.82V3.027c0-1.658-1.293-3.007-2.883-3.007z",
    transform: "translate(6 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M4.987 7.103h-1.25c-.453 0-.82.367-.82.82 0 .453.367.82.82.82h1.25c.453 0 .82-.367.82-.82 0-.453-.367-.82-.82-.82zM0 4.056L19.987 4.056 19.987 5.697 0 5.697z",
    transform: "translate(6 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment.057068dc.svg";
export { ForwardRef as ReactComponent };